import { createContext } from "react";
import { SwiperClass } from "swiper/react";

export const SwiperContext = createContext<{
	swiperState: SwiperClass | null;
	setSelectedSlideIndex: (index: number) => void;
}>({
	swiperState: null,
	setSelectedSlideIndex: () => {},
});
